import { render, staticRenderFns } from "./AuthError.vue?vue&type=template&id=4861b1fa&"
import script from "./AuthError.vue?vue&type=script&lang=ts&"
export * from "./AuthError.vue?vue&type=script&lang=ts&"
import style0 from "./AuthError.vue?vue&type=style&index=0&id=4861b1fa&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports